import { Grid, Typography } from "@mui/material";
import React from "react";
import WSSelectField from "../../../../Components/Select/WSSelect";
import config from "../../../../Config/clientConfig.json";
import { useFormContext } from "react-hook-form";
import WSTextField, { TextType } from "../../../../Components/TextBox/WSTextBox";

export const Numbering: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();

  return (
    <>
      <Typography>Document Numbering</Typography>

      <Grid container spacing={2} mt={2}>
        <Grid item xs={12} sm={3}>
          <Typography mt={4}>Issue No</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            options={config.doctypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("type")}
            id="type"
            control={control}
            defaultValue={"0"}
            label="Type"
            name="type"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="prefix"
            {...register("prefix")}
            rules={{ required: true }}
            name="prefix"
            label="Prefix "
            labelType="Normal"

          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="startFrom"
            {...register("startFrom")}
            rules={{ required: true }}
            name="startFrom"
            label="Start From "
            type={TextType.Number}
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography >Goods Receipt No</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            options={config.doctypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("type1")}
            id="type1"
            control={control}
            defaultValue={"0"}
            label=""
            name="type1"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="prefix1"
            {...register("prefix1")}
            rules={{ required: true }}
            name="prefix1"
            label=" "
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="startFrom1"
            {...register("startFrom1")}
            rules={{ required: true }}
            name="startFrom1"
            label=" "
            type={TextType.Number}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography >Goods Return No</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            options={config.doctypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("type2")}
            id="type2"
            control={control}
            defaultValue={"0"}
            label=""
            name="type2"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="prefix2"
            {...register("prefix2")}
            rules={{ required: true }}
            name="prefix2"
            label=" "
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="startFrom2"
            {...register("startFrom2")}
            rules={{ required: true }}
            name="startFrom2"
            label=" "
            type={TextType.Number}
          />
        </Grid><Grid item xs={12} sm={3}>
          <Typography >Indent/Requisition</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            options={config.doctypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("type3")}
            id="type3"
            control={control}
            defaultValue={"0"}
            label=""
            name="type3"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="prefix3"
            {...register("prefix3")}
            rules={{ required: true }}
            name="prefix3"
            label=" "
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="startFrom3"
            {...register("startFrom3")}
            rules={{ required: true }}
            name="startFrom3"
            label=" "
            type={TextType.Number}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography >Order No</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            options={config.doctypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("type4")}
            id="type4"
            control={control}
            defaultValue={"0"}
            label=""
            name="type4"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="prefix4"
            {...register("prefix4")}
            rules={{ required: true }}
            name="prefix4"
            label=" "
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="startFrom4"
            {...register("startFrom4")}
            rules={{ required: true }}
            name="startFrom4"
            label=" "
            type={TextType.Number}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography >Indent/Requisition</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            options={config.doctypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("type3")}
            id="type3"
            control={control}
            defaultValue={"0"}
            label=""
            name="type3"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="prefix3"
            {...register("prefix3")}
            rules={{ required: true }}
            name="prefix3"
            label=" "
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="startFrom3"
            {...register("startFrom3")}
            rules={{ required: true }}
            name="startFrom3"
            label=" "
            type={TextType.Number}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography >Manufacturing No</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            options={config.doctypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("type5")}
            id="type5"
            control={control}
            defaultValue={"0"}
            label=""
            name="type5"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="prefix5"
            {...register("prefix5")}
            rules={{ required: true }}
            name="prefix5"
            label=" "
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="startFrom5"
            {...register("startFrom5")}
            rules={{ required: true }}
            name="startFrom5"
            label=" "
            type={TextType.Number}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Typography >Market List No</Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSSelectField
            options={config.doctypeConfig.staticOptionData}
            rules={{ required: true }}
            {...register("type6")}
            id="type6"
            control={control}
            defaultValue={"0"}
            label=""
            name="type6"
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="prefix6"
            {...register("prefix6")}
            rules={{ required: true }}
            name="prefix6"
            label=" "
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <WSTextField
            control={control}
            id="startFrom6"
            {...register("startFrom6")}
            rules={{ required: true }}
            name="startFrom6"
            label=" "
            type={TextType.Number}
          />
        </Grid>
      </Grid>
    </>
  );
});
